module.exports = __webpack_public_path__ + "img/photo_books_1.fb439901.png";